/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOtherOpexDto } from '../../models/backend-other-opex-dto';
import { BackendPatchedOtherOpexRequestDto } from '../../models/backend-patched-other-opex-request-dto';

export interface OpexesOtheropexPartialUpdate$Params {
  id: number;
  body?: BackendPatchedOtherOpexRequestDto;
}

export function opexesOtheropexPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesOtheropexPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
  const rb = new RequestBuilder(rootUrl, opexesOtheropexPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOtherOpexDto>;
    }),
  );
}

opexesOtheropexPartialUpdate.PATH = '/api/opexes/otheropex/{id}/';
